
import { LinesTitle, LinesList } from "./Lines";

export const CheckListDetailed = (props) => {
    const { details, classes, clsx, selected } = props;
    return (
        <div className={clsx(classes.printFullPage)}>
            <div className={classes.downloadbars}>
                <div className={classes.downloadtopbar}></div>
                <div className={classes.downloadsecondbar} style={{ lineHeight: 1 }}>Product Delivery Checklist - Detailed</div>
            </div>
            <div className={clsx(classes.downloaddetails)}>
                <div className={clsx(classes.padding20)}>
                    {
                        details && Object?.entries(details)?.map(([key, value]) => (
                            <div key={key} className={clsx(classes.invoiceRow, 'no-break')} style={{ position: "relative" }}>
                                <div className={clsx(classes.typographyHeader, classes.bold, classes.fonSize15)}>{value?.invoices[0]?.customerName}</div>
                                {
                                    value.invoices && value.invoices?.filter((el) => { return selected.find(e => e === el.id) })?.map((data, i) => (
                                        <div key={i} className={clsx(classes.pageBreakRow)}>
                                            <LinesTitle {...props} data={data} />
                                            <LinesList {...props} data={data?.salesInvoiceItems} />
                                        </div>
                                    ))
                                }
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}